import './Menu';
import './ADAMenu';
import { isDesktop } from '../../utils';
import { PIN_HEADER_EVENT, MOUSE_WHEEL_CUSTOM_EVENT } from '../../constants';

export default class Header {
  constructor() {
    this.attributes = {
      dataScrollY: 'data-scroll-y',
      dataSegmentKey: 'data-segment-key',
    };

    this.classes = {
      pinHeader: 'pin-header',
      isOpenMenu: 'is-open-menu',
      wheelDown: 'wheel-down',
      wheelUp: 'wheel-up',
      hide: 'hide-header',
      actionOpenMenuMb: 'is-action-open-menu',
    };

    this.tags = {
      focusItem: 'input, a, button',
    };

    this.dom = {
      $html: $('html'),
      $body: $('body'),
      $header: $('#header'),
      $form: $('#header .form-search'),
      $popupSearch: $('.popup-search'),
      $segmentTabs: $('[data-segment-key]'),
      $productLinks: $('.product-links-bar [data-segment-key]'),
    };

    this.$topHeader = this.dom.$header.find('.header-top');
    this.positionFlag = 0;
    this.numberScroll = 16;
  }

  init() {
    if (this.dom.$header.length) {
      this.wheelUpEvent = new CustomEvent('wheelUpCustom');
      this.wheelDownEvent = new CustomEvent('wheelDownCustom');
      this.wheelUpEvent2 = new CustomEvent(MOUSE_WHEEL_CUSTOM_EVENT, { detail: { wheel: 'up' } });
      this.wheelDownEvent2 = new CustomEvent(MOUSE_WHEEL_CUSTOM_EVENT, { detail: { wheel: 'down' } });
      this.pinHeaderEvent = new CustomEvent(PIN_HEADER_EVENT, { detail: { pinHeader: true } });
      this.unPinHeaderEvent = new CustomEvent(PIN_HEADER_EVENT, { detail: { pinHeader: false } });
      window.showMainNav = true;
      this.settingPin();
      this.setVariablesCssHeader();
      this.addEventListeners();
      this.checkSubmitFormSearch();
      this.initSegmentTabEvents();
    }
  }

  addEventListeners() {
    window.scrollAgent.scrollEvent((args) => {
      if (isDesktop()) {
        this.windowScrollTop = parseFloat(args.scroll.y.toFixed(2));
        if (!this.dom.$html.hasClass(this.classes.isOpenMenu) && (this.positionFlag !== this.windowScrollTop)) {
          this.positionFlag = this.windowScrollTop;
          this.settingPin();
        }
      }
      this.handleMouseWheelUpDown(args);
    });

    document.addEventListener('scroll', () => {
      if (!isDesktop()) {
        this.windowScrollTop = window.pageYOffset;
        if (!this.dom.$html.hasClass(this.classes.isOpenMenu)) {
          this.settingPin();
        }
      }
    });
    $(window).on('resize orientationchange', () => {
      clearTimeout(this.timerResize);
      this.timerResize = setTimeout(() => {
        this.settingPin();
        this.setVariablesCssHeader();
      }, 200);
    });
  }

  checkSubmitFormSearch() {
    this.dom.$form.on('submit', (e) => {
      e.preventDefault();
      const $input = this.dom.$form.find('input[type="text"]');
      if ($input.val().trim() !== '') {
        window.location.href = `/search?search=${encodeURIComponent($input.val())}`;
      }
    });
  }

  settingPin(scroll = 0) {
    if (!this.dom.$html.hasClass(this.classes.actionOpenMenuMb)) {
      const scrollTop = this.windowScrollTop ? this.windowScrollTop : 0 + scroll;
      this.dom.$header.addClass('bg-pin-header');
      if (scrollTop < 200 && (!this.dom.$body.hasClass('has-color-full-header') || this.dom.$header.hasClass('highlight-main-nav'))) {
        this.dom.$header.removeClass('bg-pin-header');
      }

      if (!this.dom.$body.hasClass('first-tab-active') && this.dom.$html.hasClass('safari')) {
        this.numberScroll = 0;
      } else {
        this.numberScroll = 16;
      }
      if (scrollTop > this.numberScroll) {
        this.dom.$header.addClass(this.classes.pinHeader);
        this.dom.$body.addClass(this.classes.pinHeader);
        window.dispatchEvent(this.pinHeaderEvent);
      } else {
        this.dom.$header.removeClass(this.classes.pinHeader);
        if (!this.dom.$body.hasClass('trim-template') || this.dom.$body.hasClass('first-tab-active')) {
          this.dom.$body.removeClass(this.classes.pinHeader);
        }
        this.dom.$body.removeClass(this.classes.wheelUp).removeClass(this.classes.wheelDown);
        window.dispatchEvent(new CustomEvent('unPinHeader'));
        window.dispatchEvent(this.unPinHeaderEvent);
      }
    }
  }

  handleMouseWheelUpDown(args) {
    if (!this.dom.$html.hasClass(this.classes.actionOpenMenuMb)) {
      const scrollY = Math.round(this.dom.$body.attr(this.attributes.dataScrollY) - 400);
      // dispatch new window customEvent for mouse wheel up and down
      if (args.direction === 'down' || !window.showMainNav) {
        this.dom.$body.addClass(this.classes.wheelDown).addClass(this.classes.pinHeader).removeClass(this.classes.wheelUp)
          .attr(this.attributes.dataScrollY, Math.round(this.windowScrollTop));
        this.dom.$header.addClass(this.classes.hide);
        this.dom.$popupSearch.removeClass('active');
        this.dom.$popupSearch.find(this.tags.focusItem).attr('tabindex', '-1');
        this.dom.$body.removeClass('open-header');
        window.dispatchEvent(this.wheelUpEvent);
        window.dispatchEvent(this.wheelDownEvent2);
      } else if (scrollY > this.windowScrollTop) {
        this.dom.$header.removeClass(this.classes.hide);
        this.dom.$body.addClass(this.classes.wheelUp).removeClass(this.classes.wheelDown);
        window.dispatchEvent(this.wheelDownEvent);
        window.dispatchEvent(this.wheelUpEvent2);
      } else {
        // do nothing
      }

      if (this.windowScrollTop === 0) {
        this.dom.$body.removeClass(this.classes.wheelUp).removeClass(this.classes.wheelDown);
      }
    }
  }

  setVariablesCssHeader() {
    // set css variables for header height using other module or component: sub-navigation, banner, ...
    // const headerHeight = this.dom.$header.outerHeight();
    // const topHeaderHeight = this.$topHeader.outerHeight();
    if (this.$topHeader.length < 1) {
      this.dom.$header.addClass('no-top-header');
    }
    // set vars to :root
    // document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    // document.documentElement.style.setProperty('--height-top-header', `${topHeaderHeight}px`);
  }

  initSegmentTabEvents() {
    this.dom.$segmentTabs.on('click', (e) => {
      const $target = $(e.currentTarget);
      const segmentKey = $target.attr(this.attributes.dataSegmentKey);
      if (segmentKey) {
        this.updateSegmentLinks(segmentKey);
      }
    });
    // Initialize links for the default segment (first tab)
    if (this.dom.$segmentTabs.length) {
      const firstSegmentKey = this.dom.$segmentTabs.first().attr(this.attributes.dataSegmentKey);
      if (firstSegmentKey) {
        this.updateSegmentLinks(firstSegmentKey);
      }
    }
  }

  updateSegmentLinks(segmentKey) {
    // Hide all segment links
    $('.product-links-bar [data-segment-key]').addClass('hidden');

    // Show the segment link for the selected segment
    $(`.product-links-bar [data-segment-key="${segmentKey}"]`).removeClass('hidden');

    // Update the search-inventory link with the segment parameter
    const $searchInventoryLink = $('.product-links-bar a[data-link-type="search-inventory"]');
    if ($searchInventoryLink.length) {
      const currentHref = $searchInventoryLink.attr('href');
      const newHref = this.updateUrlWithSegment(currentHref, segmentKey.toLowerCase());
      $searchInventoryLink.attr('href', newHref);
    }

    // Update the compare models link with the segment parameter
    const $compareModelsLink = $('.product-links-bar a[data-link-type="compare-models"]');
    if ($compareModelsLink.length) {
      const currentHref = $compareModelsLink.attr('href');
      const newHref = this.updateUrlWithSegment(currentHref, segmentKey.toLowerCase());
      $compareModelsLink.attr('href', newHref);
    }

    // Update the help me choose link with the segment parameter
    const $helpMeChooseLink = $('.product-links-bar a[data-link-type="help-me-choose"]');
    if ($helpMeChooseLink.length) {
      const currentHref = $helpMeChooseLink.attr('href');
      const newHref = this.updateUrlWithSegment(currentHref, segmentKey.toLowerCase());
      $helpMeChooseLink.attr('href', newHref);
    }

    // Update the build your own link with the segment hash
    const $buildYourOwnLink = $('.product-links-bar a[data-link-type="build-your-own"]');
    if ($buildYourOwnLink.length) {
      const currentHref = $buildYourOwnLink.attr('href');
      const newHref = this.updateUrlWithHashSegment(currentHref, segmentKey.toLowerCase());
      $buildYourOwnLink.attr('href', newHref);

      // Special handling for build page
      $buildYourOwnLink.off('click.segmentHandler').on('click.segmentHandler', (e) => {
        const linkPathname = new URL(currentHref, window.location.origin).pathname.toLowerCase();
        // Check if we're on the build page by comparing with the link's pathname
        if (window.location.pathname.toLowerCase() === linkPathname) {
          e.preventDefault();
          // Find and click the corresponding tab in the build module
          const targetTab = $(`.mod-build-select-model button[data-title="${segmentKey.toLowerCase()}"]`);
          if (targetTab.length) {
            targetTab.trigger('click');
          }
        }
      });
    }
  }

  updateUrlWithSegment(url, segmentKey) {
    // Ensure segment key is lowercase
    const lowerCaseSegmentKey = segmentKey.toLowerCase();
    let newUrl;

    if (url.includes('?')) {
      // URL has query parameters
      const [baseUrl, queryString] = url.split('?');

      // Parse existing query parameters
      const params = {};
      queryString.split('&').forEach((param) => {
        const [key, value] = param.split('=');
        if (key && value) {
          params[key] = value;
        }
      });

      // Update or add the segment parameter
      params.segment = lowerCaseSegmentKey;

      // Reconstruct the URL
      const newQueryString = Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');

      newUrl = `${baseUrl}?${newQueryString}`;
    } else {
      // No query parameters yet
      newUrl = `${url}?segment=${encodeURIComponent(lowerCaseSegmentKey)}`;
    }

    return newUrl;
  }

  updateUrlWithHashSegment(url, segmentKey) {
    // Handles edge cases: preserves query params, replaces any existing hash, works with or without hash/query
    // Example: /build -> /build#atv
    //          /build?foo=bar -> /build?foo=bar#atv
    //          /build#old -> /build#atv
    //          /build?foo=bar#old -> /build?foo=bar#atv
    //          /build# -> /build#atv
    const hashIndex = url.indexOf('#');
    let baseUrl = url;
    if (hashIndex !== -1) {
      baseUrl = url.substring(0, hashIndex);
    }
    return `${baseUrl}#${encodeURIComponent(segmentKey)}`;
  }
}
new Header().init();
